<template>
    <div class="CourseSingupModalWarp">
        <!-- 显示报名 -->
        <el-dialog title="" :visible.sync="showSecondVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <div class="stepsBox">
                    <el-steps :active="active" align-center>
                        <el-step title="填写报名信息"></el-step>
                        <el-step title="完善报名信息"></el-step>
                        <el-step title="上传文件"></el-step>
                    </el-steps>
                </div>
                <div class="singupForm">
                    <!-- label-position="left" -->
                    <el-form :model="formData" ref="formData" :rules='formRules' label-width="112px" class="demo-dynamic" >
                        <!-- 新增 -->
                        <div class="singupInfowarp">
                            <div class="singupInfobox">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="姓名" prop="userName">
                                            <el-input placeholder="请输入姓名" v-model="formData.userName" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="民族" prop="ethnic">
                                            <el-select v-model="formData.ethnic" placeholder="请选择民族" style="width:100%">
                                                <el-option v-for="item in nationArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="性别" prop="sex">
                                            <el-select v-model="formData.sex" placeholder="请选择性别" style="width:100%" :disabled="true">
                                                <el-option v-for="item in sexArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="政治面貌" prop="politics">
                                            <el-select v-model="formData.politics" placeholder="请选择政治面貌" style="width:100%">
                                                <el-option v-for="item in politicsArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="出生日期" prop="birthDay">
                                            <el-date-picker type="date" placeholder="请选择出生日期" v-model="formData.birthDay" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                :disabled="true"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="现任职务" prop="post">
                                            <el-input placeholder="请输入现任职务" v-model="formData.post"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="身份证号码" prop="cardId">
                                            <el-input placeholder="请输入身份证号码" v-model="formData.cardId" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="管理经验年限" prop="manageList">
                                            <el-input placeholder="请输入管理经验年限" v-model="formData.manageList"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="联系电话" prop="phone">
                                            <el-input placeholder="请输入联系电话" v-model="formData.phone" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="办公电话 " prop="telPhone">
                                            <el-input placeholder="请输入办公电话 " v-model="formData.telPhone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="电子邮箱" prop="email">
                                            <el-input placeholder="请输入电子邮箱" v-model="formData.email"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <!-- <el-col :span="12">
                                        <el-form-item label="工作单位名称" prop="email">
                                            <el-input placeholder="请输入工作单位名称" v-model="formData.email" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :span="12">
                                        <el-form-item label="通讯地址 " prop="address">
                                            <el-input placeholder="请输入通讯地址 " v-model="formData.address"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="通讯地址 " prop="address">
                                            <el-input placeholder="请输入通讯地址 " v-model="formData.address"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row> -->
                            </div>
                            <div class="singupInfobox">
                                <div class="header">教育背景
                                    <span class="education">(最高学历)</span>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校" prop="school">
                                            <el-input placeholder="请输入毕业院校" v-model="formData.school"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="起止时间" prop="times">
                                            <el-date-picker v-model="formData.times" format="yyyy-MM" value-format="yyyy-MM" unlink-panels type="monthrange" range-separator="至"
                                                start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%" placeholder="请选择起止时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">

                                    <el-col :span="12">
                                        <el-form-item label="专业" prop="major">
                                            <el-input placeholder="请输入专业" v-model="formData.major"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="学历/学位" prop="education">
                                            <el-select v-model="formData.education" placeholder="请选择学历/学位" style="width:100%">
                                                <el-option v-for="item in educationArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="专业" prop="organizingCord">
                                    <el-input placeholder="请输入专业" v-model="formData.organizingCord"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="学历/学位" prop="organizingCord">
                                    <el-input placeholder="请输入学历/学位" v-model="formData.organizingCord"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                            </div>
                            <div class="singupInfobox">
                                <div class="header">企业情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业名称" prop="leaderPersionGropBo.name">
                                            <el-input placeholder="请输入企业名称" v-model="formData.leaderPersionGropBo.name" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row :gutter="0">
                                            <el-form-item label="所在区域" prop='leaderPersionGropBo.address'>
                                                <el-col :span="12">
                                                    <el-select v-model="formData.city.province" placeholder="请选择省份" @change="onProvinces($event)" style="width:100%">
                                                        <el-option v-for="item in addressProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-select v-model="formData.city.town" placeholder="请选择市区" style="width:100%" @change="onTowns($event)">
                                                        <el-option v-for="item in addressCityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                                    </el-select>
                                                </el-col>
                                                <!-- <el-col :span="12">
                                                    <el-select v-model="formData.city.province" placeholder="请选择省份" @change="onProvinces($event)" style="width:100%">
                                                        <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-select v-model="formData.city.town" placeholder="请选择市区" style="width:100%" @change="onTowns($event)">
                                                        <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                                    </el-select>
                                                </el-col> -->
                                            </el-form-item>
                                        </el-row>
                                        <!-- <el-form-item label="所在区域" prop="leaderPersionGropBo.address">
                                        <el-input placeholder="请输入所在区域" v-model="formData.leaderPersionGropBo.address"></el-input>
                                    </el-form-item> -->
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="公司网址 " prop="leaderPersionGropBo.website">
                                            <el-input placeholder="请输入公司网址 " v-model="formData.leaderPersionGropBo.website"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属行业" prop="leaderPersionGropBo.industry">
                                            <el-input placeholder="请输入所属行业" v-model="formData.leaderPersionGropBo.industry"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="是否上市" prop="leaderPersionGropBo.listed">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.listed">
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="是否设立党组织 " prop="leaderPersionGropBo.party" label-width="140px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.party">
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="领军理由(可多选)  " prop="leaderPersionGropBo.leaderReason" label-width="130px">
                                            <el-checkbox-group v-model="formData.leaderPersionGropBo.leaderReason" style="width:100%">
                                                <el-checkbox v-for="item in leadReasonArr" :label="item.dictionariesId" :key="item.dictionariesId" name="type">{{item.dictMsg}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{newyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.yesterassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yetersale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.yetersale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterstaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.yesterstaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yestergrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.yestergrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{nextyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforeassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.beforeassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforesale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.beforesale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforestaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.beforestaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforegrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.beforegrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="企业简介" prop="leaderPersionGropBo.companyIntro">
                                            <el-input placeholder="（请说明主营业务）， 限150字，可另附详细文件。" type="textarea" maxlength="150" :rows="4" v-model="formData.leaderPersionGropBo.companyIntro"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="个人简介" prop="leaderPersionGropBo.personIntro">
                                            <el-input placeholder="限150字" type="textarea" maxlength="150" show-word-limit :rows="3" v-model="formData.leaderPersionGropBo.personIntro"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row> -->
                                <div class="header">
                                    社会职务
                                    <span class="education">(请列出你所担任的社会职务或其他兼职，如人大代表、政协委员，或在协会团体中担任的职务)</span>
                                </div>
                                <div v-for="(item,
                            index) in formData.leaderPostionBoS" :key="index" style="margin-bottom:10px; " shadow="never">
                                    <!-- @change='changecheckFn(index)' -->
                                    <!-- <div slot="header" class="header">
                                    <el-checkbox v-if="showdelete" v-model="formData.domains[index].checked">序号：{{index+1}}</el-checkbox>
                                    <div v-else>序号：{{index+1}}</div>
                                </div> -->
                                    <el-row style="marginLeft:30px">
                                        <el-col :span="7">
                                            <el-form-item label="团体" :prop="'leaderPostionBoS.'+ index +'.positionGroup'" :rules="formRules.positionGroup" label-width="80px">
                                                <el-input placeholder="请输入团体" v-model="formData.leaderPostionBoS[index].positionGroup"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <div style="marginRight:10px;color:#fff">&nbsp</div>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="参加时间" :prop="'leaderPostionBoS.'+ index +'.joinTime'" :rules="formRules.joinTime" label-width="90px">
                                                <el-date-picker v-model="formData.leaderPostionBoS[index].joinTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                    placeholder="选择日期" style="width:100%">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <div style="marginRight:10px;color:#fff">&nbsp</div>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="职务" :prop="'leaderPostionBoS.'+ index +'.position'" :rules="formRules.position" label-width="80px">
                                                <el-input placeholder="请输入职务" v-model="formData.leaderPostionBoS[index].position"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <i class="el-icon-remove-outline deteleIcon" @click.prevent="removeDomain(item)" v-if="index>0" />
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="btnwarp">
                                    <div @click="addDomain" class="addbtn">
                                        <i class="el-icon-circle-plus-outline" /> 增加</div>
                                    <!-- <div @click="deleDomain" class="deletebtn" v-if="formData.domains.length>1">
                                    <i class="el-icon-remove-outline" /> 删减</div> -->
                                </div>
                                <div class="header honor">荣誉和奖励
                                    <span class="education">（企业和个人均可）</span>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="leaderPersionGropBo.honor">
                                            <el-input placeholder="请输入" type="textarea" :rows="6" v-model="formData.leaderPersionGropBo.honor"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="formBtnBox">
                            <el-button @click="submitdraftFn" class="submitdraftBtn" >保存</el-button>
                            <el-button type="primary" @click="submitForm('formData')" class="submitBtn" :loading="isloading">提交</el-button>
                            <el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="offloginVisible">不用了,谢谢</el-button>
                <el-button type="primary" @click="gologin">好的</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
    props: {
        secondVisible: {
            type: Boolean,
            default: false
        },
        leartrainData: {
            type: Object,
            default: null
        },
    },
    // watch: {
    //     secondVisible(oldVal, newVal) {
    //         // console.log(this.secondVisible,'secondVisible');
    //         // console.log(oldVal, newVal,'完善信息');
    //         this.showSecondVisible = this.secondVisible
    //     },
    //     deep: true,// 深度监听（例如对象中的数据）
    //     immediate: true//立即执行监听
    // },
    data() {
        return {
            showSecondVisible: true,
            active: 1,
            // 报名表单
            formData: {
                // 个人
                userName: null,
                sex: null,
                ethnic: null,
                birthDay: null,
                cardId: null,
                politics: null,
                post: null,
                manageList: null,
                phone: null,
                telPhone: null,
                email: null,
                address: null,
                school: null,
                times: null,
                major: null,
                education: null,
                city: { // 地区联动
                    province: null,
                    town: null,
                },
                // 开票所在地区
                areacity: {
                    province: null,
                    town: null,
                    county: null,
                },
                // 企业
                leaderPersionGropBo: {
                    name: null,
                    address: null,
                    website: null,
                    industry: null,
                    listed: null,
                    party: null,
                    leaderReason: [],
                    companyIntro: null,
                    personIntro: null,
                    honor: null,
                    // 资产
                    propertyBo: {
                        yesterassets: null,
                        yetersale: null,
                        yesterstaffNum: null,
                        yestergrowth: null,
                        beforeassets: null,
                        beforesale: null,
                        beforestaffNum: null,
                        beforegrowth: null
                    },
                },
                // 社会职务
                leaderPostionBoS: [{
                    positionGroup: null,
                    joinTime: null,
                    position: null
                }],
            },
            formRules: {
                userName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                sex: [
                    { required: true, message: '性别不能为空', trigger: 'blur' }
                ],
                ethnic: [
                    { required: true, message: '民族不能为空', trigger: 'blur' }
                ],
                birthDay: [
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
                cardId: [
                    { required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                politics: [
                    { required: true, message: '政治面貌不能为空', trigger: 'blur' }
                ],
                post: [
                    { required: true, message: '现任职务不能为空', trigger: 'blur' }
                ],
                manageList: [
                    { required: true, message: '管理经验年限不能为空', trigger: 'blur' }
                ],
                phone: [
                    {
                        required: true, message: '手机号码不能为空', trigger: 'blur'
                    },
                    {
                        required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
                    }
                ],
                // telPhone: [
                //     {
                //         required: true, message: '办公电话不能为空', trigger: 'blur'
                //     }
                // ],
                'email': [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'address': [
                    {
                        required: true, message: '通讯地址不能为空', trigger: 'blur'
                    }
                ],
                'school': [
                    {
                        required: true, message: '毕业院校不能为空', trigger: 'blur'
                    }
                ],
                'times': [
                    { required: true, message: '请选择起止日期', trigger: 'change' }
                ],
                'major': [
                    {
                        required: true, message: '专业不能为空', trigger: 'blur'
                    }
                ],
                'education': [
                    {
                        required: true, message: '学历/学位 不能为空', trigger: 'blur'
                    }
                ],
                // 'leaderPersionGropBo.website': [
                //     {
                //         required: true, message: '公司网址不能为空', trigger: 'blur'
                //     }
                // ],
                'leaderPersionGropBo.industry': [
                    {
                        required: true, message: '所属行业不能为空', trigger: 'blur'
                    }
                ],

                'leaderPersionGropBo.name': [
                    {
                        required: true, message: '企业名称不能为空', trigger: 'blur'
                    }
                ],
                'leaderPersionGropBo.address': [
                    { required: true, message: '请选择所在区域', trigger: 'change' }
                ],

                'leaderPersionGropBo.listed': [
                    { required: true, message: '请选择是否上市 ', trigger: 'change' }
                ],
                'leaderPersionGropBo.party': [
                    { required: true, message: '请选择是否设立党组织 ', trigger: 'change' }
                ],
                'leaderPersionGropBo.leaderReason': [
                    // { required: true, message: '请至少选择一个', trigger: 'change' }
                    { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
                ],
                'leaderPersionGropBo.propertyBo.yesterassets': [
                    { required: true, message: ' 请输入资产总额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yetersale': [
                    { required: true, message: ' 请输入年销售额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yesterstaffNum': [
                    { required: true, message: ' 请输入员工人数', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yestergrowth': [
                    { required: true, message: ' 请输入年利润增长率（与上一年比较）', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforeassets': [
                    { required: true, message: ' 请输入资产总额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforesale': [
                    { required: true, message: ' 请输入年销售额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforestaffNum': [
                    { required: true, message: ' 请输入员工人数', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforegrowth': [
                    { required: true, message: ' 请输入年利润增长率（与上一年比较）', trigger: 'blur' }
                ],
                'leaderPersionGropBo.companyIntro': [
                    { required: true, message: ' 请输入企业简介', trigger: 'blur' },
                    { max: 150, message: '请控制在150个字符以内', trigger: 'blur' }
                ],
                'leaderPersionGropBo.personIntro': [
                    { required: true, message: ' 请输入个人简介', trigger: 'blur' },
                    { max: 150, message: '请控制在150个字符以内', trigger: 'blur' }
                ],
                // positionGroup: [
                //     { required: true, message: ' 请输入团体 ', trigger: 'blur' }
                // ],
                // joinTime: [
                //     { required: true, message: ' 请输入参加时间 ', trigger: 'change' }
                // ],
                // position: [
                //     { required: true, message: ' 请输入职务 ', trigger: 'blur' }
                // ],
                // 'leaderPersionGropBo.honor': [
                //     { required: true, message: ' 请输入荣誉和奖励', trigger: 'blur' }
                // ],
            },
            singupserialNumber: 1,
            showdelete: false,
            kindVal: null,
            billnatureValue: null,
            selectVal: null,
            newyear: '',
            nextyear: '',
            ProvinceArr: [],//省
            addressProvinceArr: [],
            CityArr: [],//市
            addressCityArr: [],
            CountyArr: [],
            politicsArr: [],//政治面貌
            nationArr: [],//民族
            educationArr: [],//学历
            leadReasonArr: [],//领军人才理由
            sexArr: [],//性别
            isloading: false,
        }
    },
    created() {
        // 获取当前年的前2年
        let date = new Date();
        this.newyear = date.getFullYear() - 1
        this.nextyear = date.getFullYear() - 2
    },
    mounted() {
        // 获取省的数据
        this.getProvinceFn()
        // 数据字典
        this.dataDictionaryFn()
        // 回填表单
        this.getyetFormFn()
    },
    methods: {
        dataDictionaryFn() {
            // 政治面貌
            let p1 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'politics' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 民族
            let p2 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'nation' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 学历education
            let p3 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'education' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 领军人才理由 leadReason
            let p4 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'leadReason' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 性别 sex
            let p5 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'sex' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            Promise.all([p1, p2, p3, p4, p5]).then(res => {
                if (res) {
                    this.politicsArr = res[0].result;
                    this.nationArr = res[1].result;
                    this.educationArr = res[2].result;
                    this.leadReasonArr = res[3].result;
                    this.sexArr = res[4].result;
                }
            })
        },
        // 省市县
        getProvinceFn() {
            httpService.getProvince().then(res => {
                if (res.code == 200) {
                    this.ProvinceArr = res.result
                    this.addressProvinceArr = res.result
                }
            })
        },
        // 选择省
        onProvinces(event) {
            let provinceId
            this.addressProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.formData.city.town = '';
            this.getCityData(provinceId)
        },
        // 获取市
        getCityData(provinceId) {
            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.addressCityArr = res.result
                }
            })
        },
        // 选择市
        onTowns(event) {
            this.formData.leaderPersionGropBo.address = `${this.formData.city.province},${this.formData.city.town}`
        },
        // 报名表单
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isloading = true
                    // this.formData.status = 0
                    this.formData.auditResult = 99
                    if (Array.isArray(this.formData.leaderPersionGropBo.address)) {
                        this.formData.leaderPersionGropBo.address = this.formData.leaderPersionGropBo.address.join(',')
                    }
                  
                    this.formData.trainId = this.leartrainData.trainId
                    let newdataform = JSON.parse(JSON.stringify(this.formData))
                    if (Array.isArray(newdataform.times)) {
                        newdataform.times = newdataform.times.join('~')
                    }
                    if (Array.isArray(newdataform.leaderPersionGropBo.leaderReason)) {
                        if (newdataform.leaderPersionGropBo.leaderReason.length != 0) {
                            newdataform.leaderPersionGropBo.leaderReason = newdataform.leaderPersionGropBo.leaderReason.join(',')
                        } else {
                            newdataform.leaderPersionGropBo.leaderReason = ''
                        }
                    }
                    let key = { joinTime: "", position: "", positionGroup: "" };
                    newdataform.leaderPostionBoS = []
                    this.formData.leaderPostionBoS.map(item => {
                        let flag = 0;
                        for (let k in key) {
                            if (item[k] == "") {
                                flag++;
                            }
                        }
                        if (flag !== 3) {
                            newdataform.leaderPostionBoS.push(item)
                        }
                    })
                    delete newdataform.city
                    delete newdataform.areacity
                    httpService.addLeaderTalent(newdataform).then(res => {
                        if (res) {
                            this.isloading = false
                            if (res.code == 200) {
                                this.$message({
                                    message: '详细信息提交成功',
                                    type: 'success'
                                });
                                this.getyetFormFn()
                                sessionStorage.setItem('downloadFile', res.result)
                                // this.$emit('update:isShow', false)
                                if (!this.isCustom) this.$destroy(this.$emit('changeShowSecond', false)) // 销毁当前组件
                            } else {
                                this.$message.error(res.message);
                            }
                        }
                    })
                } else {
                    this.$nextTick(() => {
                        formErrorScroll()
                    })
                    return false;
                }
            });
        },
        // 存为草稿
        submitdraftFn() {
            // this.formData.status = 0//0草稿
            this.formData.auditResult = 98
            if (!this.formData.userName && !this.formData.cardId && !this.formData.phone) {
                this.$message.error('姓名、身份证号码和手机号为必填项，请填写');
            } else {
                if (Array.isArray(this.formData.leaderPersionGropBo.address)) {
                    this.formData.leaderPersionGropBo.address = this.formData.leaderPersionGropBo.address.join(',')
                }
               
                this.formData.trainId = this.leartrainData.trainId
                let newdataform = JSON.parse(JSON.stringify(this.formData))
                if (Array.isArray(newdataform.times)) {
                    newdataform.times = newdataform.times.join('~')
                }
                if (Array.isArray(newdataform.leaderPersionGropBo.leaderReason)) {
                    if (newdataform.leaderPersionGropBo.leaderReason.length != 0) {
                        newdataform.leaderPersionGropBo.leaderReason = newdataform.leaderPersionGropBo.leaderReason.join(',')
                    } else {
                        newdataform.leaderPersionGropBo.leaderReason = ''
                    }
                }
                let key = { joinTime: "", position: "", positionGroup: "" };
                newdataform.leaderPostionBoS = []
                this.formData.leaderPostionBoS.map(item => {
                    let flag = 0;
                    for (let k in key) {
                        if (item[k] == "") {
                            flag++;
                        }
                    }
                    if (flag !== 3) {
                        newdataform.leaderPostionBoS.push(item)
                    }
                })
                delete newdataform.city
                delete newdataform.areacity
                httpService.addLeaderTalent(newdataform).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        // this.getyetFormFn()
                        // this.$emit('update:isShow', false)
                        // this.$emit('offseconfModal', true)
                        if (!this.isCustom) this.$destroy(this.$emit('changeShowSecond', false)) // 销毁当前组件
                    } else {
                        this.$message.error(res.message);
                    }
                })
            }
        },
        // 回填表单
        getyetFormFn() {
            httpService.getSingleLeaderTalen().then(res => {
                if (res.code == 200) {
                    delete res.result.leaderResourceWayVo
                    res.result.city = {
                        province: '',
                        town: '',
                    }
                    res.result.areacity = {
                        province: '',
                        town: '',
                        county: '',
                    }
                    if (res.result.leaderPersionGropVo) {
                        if (res.result.leaderPersionGropVo.address) {
                            res.result.leaderPersionGropVo.address = res.result.leaderPersionGropVo.address.split(',')
                            res.result.city.province = res.result.leaderPersionGropVo.address[0]
                            res.result.city.town = res.result.leaderPersionGropVo.address[1]
                        } else {
                            res.result.city.province = '';
                            res.result.city.town = '';
                        }
                        // 转领军理由
                        if (res.result.leaderPersionGropVo.leaderReason) {
                            res.result.leaderPersionGropVo.leaderReason = res.result.leaderPersionGropVo.leaderReason.split(',')
                        } else {
                            res.result.leaderPersionGropVo.leaderReason = []
                        }
                        // res.result.leaderPersionGropVo.leaderReason=[]
                        // 资产
                        if (res.result.leaderPersionGropVo.propertyVoo) {
                            res.result.leaderPersionGropVo.propertyBo = res.result.leaderPersionGropVo.propertyVoo
                        } else {
                            res.result.leaderPersionGropVo.propertyBo = {
                                yesterassets: '',
                                yetersale: '',
                                yesterstaffNum: '',
                                yestergrowth: '',
                                beforeassets: '',
                                beforesale: '',
                                beforestaffNum: '',
                                beforegrowth: ''
                            }
                        }
                        // 企业
                        res.result.leaderPersionGropBo = res.result.leaderPersionGropVo
                    }
                    else {
                        res.result.leaderPersionGropBo = {
                            name: '',
                            address: '',
                            website: '',
                            industry: '',
                            listed: '',
                            party: '',
                            leaderReason: [],
                            companyIntro: '',
                            personIntro: '',
                            honor: '',
                            // 资产
                            propertyBo: {
                                yesterassets: '',
                                yetersale: '',
                                yesterstaffNum: '',
                                yestergrowth: '',
                                beforeassets: '',
                                beforesale: '',
                                beforestaffNum: '',
                                beforegrowth: ''
                            },
                        }
                    }
                    // 社会职务为空时
                    if (!res.result.leaderPostionVos || res.result.leaderPostionVos.length == 0) {
                        res.result.leaderPostionBoS = [{
                            positionGroup: '',
                            joinTime: '',
                            position: ''
                        }]
                    } else {
                        res.result.leaderPostionBoS = res.result.leaderPostionVos
                    }
                    // 转时间
                    if (res.result.times) {
                        res.result.times = res.result.times.split('~')
                    }
                    delete res.result.leaderPersionGropVo
                    delete res.result.leaderPersionGropBo.propertyVoo
                    delete res.result.leaderPostionVos
                    delete res.result.busBillInfoVo
                    this.formData = res.result
                    // 所在区域
                    if (this.formData.city.town) {
                        let provinceId
                        this.addressProvinceArr.map(item => {
                            if (item.province === this.formData.city.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getCityData(provinceId)
                    }
                    // 所在地區
                    if (this.formData.areacity.town) {
                        let provinceId
                        this.ProvinceArr.map(item => {
                            if (item.province === this.formData.areacity.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getareaCityData(provinceId)
                    }
                    if (this.leartrainData != null) {
                        this.$nextTick(() => {
                            // DOM 更新了
                            this.$refs["formData"].clearValidate()
                        })
                    }
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        removeDomain(item) {
            var index = this.formData.leaderPostionBoS.indexOf(item)
            if (index !== -1) {
                this.formData.leaderPostionBoS.splice(index, 1)
            }
            this.singupserialNumber = this.singupserialNumber - 1
        },
        addDomain() {
            this.formData.leaderPostionBoS.push({
                positionGroup: '',
                joinTime: '',
                position: ''
            });
            this.singupserialNumber = this.singupserialNumber++
        },
        deleDomain() {
            this.formData.leaderPostionBoS.forEach((ele, index) => {

                if (ele.checked) {
                    this.formData.leaderPostionBoS.splice(index)
                }
                else {
                    this.showdelete = true
                }
            });
        },
       
        // 关闭表单
        offmodalFn() {
            // this.$emit('update:isShow', false)
            this.$emit('changeShowSecond', false)
            if (!this.isCustom) this.$destroy(this.$emit('changeShowSecond', false)) // 销毁当前组件
        }
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
    	.singupdialogcenter::-webkit-scrollbar {
			width: 8px;
			/*height: 4px;*/
		}
		.singupdialogcenter::-webkit-scrollbar-thumb {
			border-radius: 10px;
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			background: rgba(0, 0, 0, 0.2);
		}
		.singupdialogcenter::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}
	/deep/.singupdialogcenter {
		// padding: 17px 0px 0px 0px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 640px;
		overflow-y: auto;
		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 100px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.stepsBox {
			width: 100%;
		}
		.singupForm {
			width: 100%;
			margin-top: 36px;
			.singupInfowarp {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 82px;
			}
			.singupInfobox {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				padding: 0 50px;

				.header {
					margin-bottom: 12px;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
					}
				}
				// .honor {
				// 	// margin-left: 20px;
				// 	position: relative;
				// 	&::before {
				// 		position: absolute;
				// 		top: 16px;
				// 		left: -10px;
				// 		// margin-right: 4px;
				// 		color: #ff4d4f;
				// 		font-size: 16px;
				// 		font-family: SimSun, sans-serif;
				// 		line-height: 1;
				// 		content: '*';
				// 	}
				// }
				.btnwarp {
					font-size: 16px;
					// line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.header {
				font-size: 18px;
				line-height: 54px;
				color: #333333;
				.education {
					font-size: 16px;
					line-height: 54px;
					color: #999999;
					padding-left: 6px;
				}
			}
			.educationInfoBox {
				.header {
					margin-left: 48px;
				}
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 0px 30px 0px;
			}
			.makeoutInfoBox {
				// border-bottom: 1px solid #dddddd;
				margin-bottom: 0px;
				padding: 0 50px 30px 50px;
				.header {
					font-size: 18px;
					line-height: 54px;
					color: #333333;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
						padding-left: 6px;
					}
				}
			}

			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}
				.submitdraftBtn {
					width: 152px;
					height: 40px;
					background: #52ca9c;
					margin: 0 20px;
					color: #fff;
				}
				.cancelBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
		}
	}
	.yearbox {
		font-size: 15px;
		line-height: 40px;
		color: #a6a9b7;
		&::before {
			position: absolute;
			top: 12px;
			left: 0px;
			// margin-right: 4px;
			color: #ff4d4f;
			font-size: 16px;
			font-family: SimSun, sans-serif;
			line-height: 1;
			content: '*';
		}
	}
	.deteleIcon {
		font-size: 21px;
		cursor: pointer;
		color: red;
		line-height: 40px;
		margin-left: 4px;
	}
}
// 默认当前激活步骤显示的是黑色，这里修改显示为蓝色
::v-deep .el-step__head.is-process {
	color: #1890ff !important; // 圆圈中数字
	border-color: #1890ff !important; // 圆圈
}
::v-deep .el-step__title.is-process {
	color: #1890ff !important; // 圆圈下的标题文本
}
:v-deep .el-step__head.is-success {
	color: rgb(52, 158, 250);
	border-color: rgb(52, 158, 250);
}
::v-deep .el-step__title.is-success {
	font-weight: bold;
	color: rgb(52, 158, 250);
}
::v-deep .el-step__head is-finish {
	color: rgb(52, 158, 250);
}
</style>


